import * as Colors from '../colors';

export default {
  root: {
    backgroundColor: Colors.DividersAndCardBorders,
  },
};
